import axios from "axios";

export async function call(number, ramal, from, to) {
  const token = process.env.VUE_APP_API4COM_TOKEN;
  const extension = ramal;
  const queue = extension;
  const url = `${process.env.VUE_APP_API4COM_API_URL}?${token}&${number}&${queue}&${extension}`;
  const headers = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const body = JSON.stringify({
    caller: extension,
    called: number,
    extension,
    metadata: {
      from,
      to,
    },
  });
  console.log(url);
  // Realiza a ligacao
  try {
    const response = await axios.post(url, body, { headers });
    if (response.status === 200) {
      console.log("Chamada criada com sucesso!");
    } else {
      console.log("Erro ao criar chamada");
    }
  } catch (error) {
    throw error;
  }
}
